import { Panel, PageHeader } from "@/components/Panel";
import { ChatConsole } from "@/components/ChatConsole";
import { BriefingButton } from "@/components/BriefingButton";
import { useResource } from "@/lib/api";
import { useState } from "react";
import { X } from "lucide-react";
import { AgendaItem } from "@/components/AgendaItem";
import { PendingBanner } from "@/components/IntegrationPanels";

export default function Command() {
  const [activity] = useResource("/activity");
  const [agenda] = useResource("/calendar/today");
  const [brief, setBrief] = useState("");
  return (
    <div>
      <PageHeader code="SYS://COMMAND-CENTER" title="Command Center" sub="Speak or type. JARVIS runs your Omvexis portal: shipments, buyers, payment notices, approvals and website enquiries."
        right={<BriefingButton onText={setBrief} />} />
      <PendingBanner />
      {brief && (
        <Panel className="mb-6" label="Morning Briefing" testId="briefing-panel" right={<button onClick={() => setBrief("")} className="text-slate-400 hover:text-white" data-testid="briefing-close"><X size={16} /></button>}>
          <p className="font-mono-hud text-[13px] leading-relaxed text-cyan-100 whitespace-pre-wrap" data-testid="briefing-text">{brief}</p>
        </Panel>
      )}
      <div className="grid grid-cols-1 2xl:grid-cols-[1fr_340px] gap-6">
        <Panel label="Neural Link // Claude Sonnet 4.5" title="JARVIS Console" testId="jarvis-console">
          <ChatConsole />
        </Panel>
        <div className="space-y-6">
        <Panel label={`Calendar // Today · ${agenda?.timezone || ""}`} title="Agenda" testId="agenda-panel">
          {!agenda?.connected ? (
            <p className="text-slate-500 text-sm" data-testid="agenda-empty">No calendar linked. Add one in Settings.</p>
          ) : agenda.events.length === 0 ? (
            <p className="text-slate-500 text-sm" data-testid="agenda-empty">{agenda.error || "No meetings today."}</p>
          ) : (
            <ul className="space-y-2">
              {agenda.events.map((e, i) => <AgendaItem key={e.uid} e={e} i={i} />)}
            </ul>
          )}
        </Panel>
        <Panel label="Telemetry" title="Activity Log" testId="activity-log">
          <ul className="space-y-3 max-h-[300px] overflow-y-auto hud-scroll pr-2">
            {(activity || []).map((a) => (
              <li key={a.id} className="border-l border-cyan-500/30 pl-3" data-testid="activity-item">
                <div className="font-mono-hud text-[10px] text-cyan-400/70">{new Date(a.created_at).toLocaleTimeString()} · {a.kind.toUpperCase()}</div>
                <div className="text-sm text-slate-300 line-clamp-4" title={a.text}>{a.text}</div>
              </li>
            ))}
            {activity?.length === 0 && <li className="text-slate-500 text-sm">No activity yet.</li>}
          </ul>
        </Panel>
        </div>
      </div>
    </div>
  );
}
